import { FETCH_FUNCTIONAL_ROLES } from "../../actions/actionTypes";

const initialState = {
    isLoading:false,
    roles:[]
};

const reducer = (state=initialState, action)=>{  
    switch(action.type){
        case FETCH_FUNCTIONAL_ROLES.REQUEST:
            return {...state,roles:[],isLoading:true}
        case FETCH_FUNCTIONAL_ROLES.FAILURE:
            return {...state,roles:[],isLoading:false}
        case FETCH_FUNCTIONAL_ROLES.SUCCESS:           
            return {...state,roles:action.data,isLoading:false}        
        default:
            return state
    }   
}

export default reducer;
